import { getConfigFor } from "../../../../utils/configService";
import { SPLIT_FEATURES } from "../../../../utils/constants/feature";
import { AnalyticsEvent } from "../../core/AnalyticsEvent";
import { ProductClickedEventSchema } from "../../schemas/product/ProductClickedEventSchema";
import { CommonEventParams } from "../../utils/CommonParams";

export interface ProductClickedEventParams extends CommonEventParams {
    BUSINESS_VERTICAL: string,
    EVENT_CATEGORY: string,
    PRODUCTS : any,
    INDEX: string | null,
    EVENT_TYPE: string,
    QUERY_ID: string | null,
}

export class ProductClickedEvent extends AnalyticsEvent {
    constructor(params: ProductClickedEventParams) {
        super(ProductClickedEventSchema, ['segment']);
        this.createEventObject(params);
    }
}

export function trackProductClickedEvent(params: ProductClickedEventParams) {
    const { isEnabled: leapCdpReleaseOne } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_ONE)
    if (leapCdpReleaseOne) {
        new ProductClickedEvent(params).track();
    }
}